export const useKWOFileTypes = () => {
  return [
    "application/vnd.google-apps.document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "text/plain",
    "image/*",
    "image/jpeg",
    "image/png",
    "image/gif",
  ];
};
